import React from 'react'

import BillingAccountTableCreator from '../../../tableDefinitions/Billing/BillingAccount/BillingAccountTableCreator'
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import Table from '../../../components/BPMTable/TableComponents/TableWrapper/SetupTableData'

export default function BilingAccountsTable(props) {
    var tableCreatorCreator = tableCreatorCreatorFactoryCreator.getTableCreatorCreatorFromIdentifier(BillingAccountTableCreator.getId(), {tcFilters: props.filters})
    tableCreatorCreator.setParentProps(props)
    const tableCreator = tableCreatorCreator.getTableCreator('Billing Accounts')

    return (
        <Table
            TableCreator={tableCreator}
            stickyHeader
        />
    )
}